import {PermitExtensionService} from "permitextension/service";
import {usePermitExtensionsTable} from "permitextension/data";

import {EntityListPage} from "base/entity/components/container";
import {PermitExtensionFilterForm} from "permitextension/presentational/form";

const ListPermitExtensionsPage = () => {
    const {tableColumns, getCellProps} = usePermitExtensionsTable();

    return (
        <EntityListPage
            views={["table"]}
            entityName={{
                singular: "Prorrogação",
                plural: "Prorrogações",
            }}
            service={PermitExtensionService}
            tableColumns={tableColumns}
            getCellProps={getCellProps}
            filterForm={<PermitExtensionFilterForm />}
            disableNavigation
        />
    );
};
export default ListPermitExtensionsPage;
